// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Roboto_18838d', '__Roboto_Fallback_18838d'","fontStyle":"normal"},"className":"__className_18838d","variable":"__variable_18838d"};